import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function Card({
  children,
  className = '',
  id
}: CardProps) {
  return <div id={id} className={`bg-white rounded-lg shadow-[0_1px_3px_rgba(15,23,42,0.08)] p-5 mb-4 border border-slate-100 ${className}`} data-id="element-282">
      {children}
    </div>;
}